import { combineReducers } from "@reduxjs/toolkit"
import languageJudgeStore from "./language_judge/language_judge"

const languageJudgeReducers = combineReducers({
  languageJudgeStore,
})

export default languageJudgeReducers
